__turbopack_context__.v({
  "regular": "tags-module-scss-module__bMua6q__regular",
  "tags": "tags-module-scss-module__bMua6q__tags",
  "tags__button": "tags-module-scss-module__bMua6q__tags__button",
  "tags__button__active": "tags-module-scss-module__bMua6q__tags__button__active",
  "tags__list": "tags-module-scss-module__bMua6q__tags__list",
  "wide": "tags-module-scss-module__bMua6q__wide",
  "wideOnMobile": "tags-module-scss-module__bMua6q__wideOnMobile",
});
